export const TOGGLE_CLIENT_ACTION = 'TOGGLE_CLIENT_ACTION'
export const CHANGE_PROPOSAL_ACTION = 'CHANGE_PROPOSAL_ACTION'
